export const countProperties = (property, data, inputName, types) => {
  let count = 0;

  if (!data) {
    return count;
  }

  const filteredDataByTypes =
    types.length > 0 ? data.filter(item => types.includes(item.type)) : data;

  if (inputName === 'type') {
    count = data.reduce((acc, item) => (item.type === property ? acc + 1 : acc), 0);
    return count;
  }

  // console.log(filteredDataByTypes);

  if (inputName === 'minAge') {
    switch (parseInt(property)) {
      case 25:
        count = filteredDataByTypes.length;
        break;
      case 23:
        count =
          filteredDataByTypes.length -
          filteredDataByTypes.filter(item => item['minAge'] === '25 Jahre').length;
        break;
      case 21:
        count =
          filteredDataByTypes.length -
          filteredDataByTypes.filter(item => item['minAge'] === '25 Jahre').length -
          filteredDataByTypes.filter(item => item['minAge'] === '23 Jahre').length;
        break;
      default:
        count = filteredDataByTypes.filter(item => item['minAge'] === '18').length;
    }
    return count;
  }

  if (inputName === 'licence') {
    switch (property) {
      case 'C':
        count = filteredDataByTypes.length;
        break;
      case 'C1':
        count =
          filteredDataByTypes.length -
          filteredDataByTypes.filter(item => item['licenseClass'] === 'C').length;
        break;
      default:
        count = filteredDataByTypes.filter(item => item['licenseClass'] === 'B').length;
    }
    return count;
  }

  if (filteredDataByTypes.some(d => !(property in d))) {
    // Property is a value
    count = filteredDataByTypes.filter(d => Object.values(d).includes(property)).length;
  } else {
    // Property is a key
    count = filteredDataByTypes.filter(item => item[property] === true).length;
  }
  return count;
};
